import React, { useState, useEffect } from "react";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // Ensure Firebase is initialized
import { Box, Typography, IconButton, Avatar, CardHeader} from "@mui/material";
import { ChevronLeft, ChevronRight, Favorite } from "@mui/icons-material";
import { EventContext } from '../pages/Dashboard';
import { useContext } from "react";


const EventPostWithCarousel = ({ eventDocId }) => {
  const [posts, setPosts] = useState([]);
  const [authors, setAuthors] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState({}); // Tracks current image per post

  const { eventDetails } = useContext(EventContext);
  const eventCode = eventDetails?.eventCode;


  useEffect(() => {
    if (!eventDocId) return;

    const fetchPosts = async () => {
      try {
        const postsRef = collection(db, "events", eventDocId, "posts");
        const postsSnapshot = await getDocs(postsRef);
        const postList = [];

        for (const postDoc of postsSnapshot.docs) {
          const postData = postDoc.data();
          postList.push({ id: postDoc.id, ...postData });

          // Fetch author details if not already retrieved
          if (postData.postAuthorID && !authors[postData.postAuthorID]) {
            const authorRef = doc(db, "users", postData.postAuthorID);
            const authorSnap = await getDoc(authorRef);
            if (authorSnap.exists()) {
              setAuthors((prev) => ({
                ...prev,
                [postData.postAuthorID]: authorSnap.data(),
              }));
            }
          }
        }

        setPosts(postList);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPosts();
  }, [eventDocId]);

  const handleNext = (postId, totalImages) => {
    setCurrentImageIndex((prev) => ({
      ...prev,
      [postId]: (prev[postId] + 1) % totalImages || 0,
    }));
  };

  const handlePrev = (postId, totalImages) => {
    setCurrentImageIndex((prev) => ({
      ...prev,
      [postId]: (prev[postId] - 1 + totalImages) % totalImages || 0,
    }));
  };

  if (!posts.length) {
    return <Typography>Loading posts...</Typography>;
  }

  return (
    <Box sx={{ padding: 1, marginTop: 3, marginBottom: 3,
      bgcolor: 'background.paper', 
      borderRadius:3,}}>
      {posts.map((post) => {
        const author = authors[post.postAuthorID] || {};
        const currentImage = currentImageIndex[post.id] || 0;

        return (
          <Box key={post.id} sx={{ maxWidth: 800, margin: "auto", position: "relative", overflow: "hidden", borderRadius: 2, boxShadow: 0, mb: 4 }}>
            
            <CardHeader
                    avatar={<Avatar src={author.profileImage || ""} sx={{ width: 32, height: 32 }}>
                    {!author.profileImage && author.displayName ? author.displayName.charAt(0) : "?"}
                  
                  </Avatar> }
                    title={<Typography variant="body2" color="text.primary">
                    {author.displayName || "Unknown Author"} 
                  </Typography>}
                    // {author.displayName || "Unknown Author"} 
                    subheader={new Date(post.timestamp.seconds * 1000).toLocaleString()}
                  />
             {/* Author Information */}
             <Box 
            //  sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: 1 }}
             >              
                {/* <Avatar src={author.profileImage || ""} sx={{ width: 32, height: 32 }}> */}
                  {/* {!author.profileImage && author.displayName ? author.displayName.charAt(0) : "?"} */}
                 {/* { console.error("author: " + author.profileImage)} */}
                {/* </Avatar>   */}
                     
                {/* <Typography variant="subtitle1">{author.displayName || "Unknown Author"}</Typography>               */}
              </Box>

            {/* Image Carousel */}
            <Box sx={{ position: "relative", width: "100%", height: 300 }}>
              <img
                src={post.postPics[currentImage]}
                alt={`Post ${currentImage + 1}`}
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px" }}
              />

              {/* Navigation Arrows */}
              {post.postPics.length > 1 && (
                <>
                  <IconButton 
                    sx={{ 
                        position: "absolute", 
                        top: "50%", 
                        left: 10, 
                        color: "white", 
                        transform: "translateY(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", }} 
                        onClick={() => handlePrev(post.id, post.postPics.length)}>
                   <ChevronLeft />
                  </IconButton>
                  <IconButton 
                    sx={{ 
                        position: "absolute", 
                        top: "50%", 
                        right: 10, 
                        color: "white", 
                        transform: "translateY(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",}} 
                        onClick={() => handleNext(post.id, post.postPics.length)}>
                    <ChevronRight />
                  </IconButton>
                </>
              )}

              {/* Dots Indicator */}
              <Box sx={{ position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)", display: "flex", gap: "4px" }}>
                {post.postPics.map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      backgroundColor: index === currentImage ? "white" : "gray",
                      transition: "0.3s",
                    }}
                  />
                ))}
              </Box>
            </Box>

            {/* Post Content */}
            <Box sx={{ padding: 1}}>                   
              {/* Post Title and Content */}
              <IconButton aria-label="add to favorites">
                <Favorite /> 
                  <Typography variant="body2" color="textSecondary">
                    {post.postLikes}
                  </Typography>
              </IconButton>                                 
                                         
              <Typography variant="body2" color="text.secondary">
                {post.postText}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default EventPostWithCarousel;
